import CityMultipleSelector from './component/city-multiple-selector/index.js';
import Q from "q";
import _ from "underscore";
import wait_some_seconds from "nllib/src/common/wait_some_seconds";

import consumer_web_city_treeCity from "../../../../lib/data-service/haolv-default/consumer_web_city_treeCity";

export default {
    mixins: [
        CityMultipleSelector,
    ],
    data() {
        return {
            init_parameter: {
                entity_define: {
                    property_name_for_id: `id`,
                    property_name_for_list_id: `treeId`,
                    property_name_for_name: `cityName`,
                    property_name_for_children: `children`,
                    property_name_for_parent_id: `pid`,
                    property_name_for_order_index: `order_index`,
                },

                left_tree: {
                    default_expand_all: false,
                },

                dialog: {
                    title: `请选择城市`,
                },

                get_data_source() {
                    return Q.when()
                        .then(function () {
                            return consumer_web_city_treeCity();
                        })
                        .then(function (data) {
                            let datas = data.datas;

                            const all_entity_list = datas;
                            const d = {
                                type: `000`,
                                all_entity_list,
                            };
                            return Q.resolve(d);
                        })
                        .catch(function (ex) {
                            if (ex) {
                                const enable_log_error = !ex.disable_log_error;
                                if (enable_log_error) {
                                    console.error(ex);
                                    console.trace();
                                    if (ex.stack) {
                                        console.error(ex.stack);
                                    }
                                }
                            }
                            return Q.reject(ex);
                        })
                        ;
                },
            },
        }
    },
};
